export const SOCKET_MESSAGE_TYPE = {
    CLOSE_MESSAGE: 'close-message'
};

export const SOCKET_EXPORT_ERROR_TYPE = [
    'file_export_limit_failed',
    'file_export_data_limit',
    'file_export_failed',
    'file_export_memory_failed',
    'file_stream_export_data_limit'
];
export const PLATFORM_SOCKET_EXPORT_ERROR_TYPE = ['platform_file_export_failed'];

export const SOCKET_EXPORT_COMPLETE_TYPE = ['file_export_complete'];
export const PLATFORM_SOCKET_EXPORT_COMPLETE_TYPE = ['platform_file_export_complete'];

export const SOCKET_EXPORT_TYPE = [
    ...SOCKET_EXPORT_COMPLETE_TYPE,
    ...SOCKET_EXPORT_ERROR_TYPE,
    ...PLATFORM_SOCKET_EXPORT_COMPLETE_TYPE,
    ...PLATFORM_SOCKET_EXPORT_ERROR_TYPE
];
